import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { UserRoleService } from 'src/app/services/user-role.service';
import { CourseUnitsService } from '../../services/course-units.service';
import { CourseService } from '../../services/course.service';
import { FilterService } from '../../services/filter.service';
import { AddUnitModalComponent } from './add-unit-modal/add-unit-modal.component';

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.scss']
})
export class UnitsComponent implements OnInit {

  @Input('singleJob') jobData: any;
  // @Input('singleCourse') singleCourse;

  courseId: any;
  units = [
    // {
    //   title: 'unit 1 title',
    //   unit: 1,
    //   _id: '1111111111111111'
    // },
    // {
    //   title: 'unit 2 title',
    //   unit: 2,
    //   _id: '2222222222222222'
    // },
    // {
    //   title: 'unit 3 title',
    //   unit: 3,
    //   _id: '3333333333333333'
    // },
    // {
    //   title: 'unit 4 title',
    //   unit: 4,
    //   _id: '4444444444444444'
    // }
  ]
  course: any;
  afterFilter: any;
  filterActive: boolean;
  unitsCopy;
  noDataMsg
  courseTitle
  loading = false
  portfolio: any;
  allSessions: any;
  allSessionsCopy: any;
  page
  user: any;
  singleCourseToPass: any;
  isDisable: boolean = false;
  job: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isTrainer: boolean = false;
  isIQA: boolean = false;
  isClient: boolean = false;
  getRole: any;
  userRole: any;
  constructor(public _courseService: CourseService, public _courseUnitService: CourseUnitsService, public dialog: MatDialog, public _portfolioService: PortfolioService, public _userRoleService: UserRoleService,
    public _filter: FilterService, public _snackBar: MatSnackBar, private router: Router, private activatedRoute: ActivatedRoute) {
    // this.activatedRoute.paramMap.subscribe(() => {
    //   console.log("job data here   ------?  ", window.history.state)
    //   // if (window && window.history && window.history.state && window.history.state.isCourse) {
    //   //   // this.isAdmin = true
    //   //   this.getRole.isAdmin = true
    //   // }
    //   // else
    //    if (window && window.history && window.history.state && window.history.state.job) {
    //     this.job = window.history.state.job
    //     console.log("get final result of the job ....", this.job)
    //     this.getUserRole()
    //   }
    // })
  }

  ngOnInit() {


    this.user = JSON.parse(localStorage.getItem('userRoles'))

    if (this.router.url.includes('jobs')) {
      console.log("current route url", this.router.url);
      this.page = 'Job'
    }

    this.activatedRoute.params.subscribe(params => {

      if (params.courseId) {
        this.courseId = params.courseId
        this.getCourseById()
        this.getUnits()
      }



    })

    this.activatedRoute.queryParams.subscribe(qparam => {
      if (qparam.userRole) {
        console.log("param ?????? ", qparam);
        this.userRole = qparam.userRole
        this.getUserRole()
      }
    })
    this.activatedRoute.queryParams.subscribe(qparam => {
      if (qparam.portfolioId) {
        this.getSessions(qparam.portfolioId)
      }
    })

    // this.getQuizListOfCourse()

  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("when it is call===============", changes.jobData);
    if (changes.jobData && changes.jobData.currentValue) {
      this.courseId = changes.jobData.currentValue.course._id
      this.getCourseById()
      this.getUnits()
      if (changes.jobData.currentValue.course.portfolioId) {
        this.getSessions(changes.jobData.currentValue.course.portfolioId)
      }
    }

    // if(changes.singleCourse && changes.singleCourse.currentValue){
    //   this.singleCourseToPass = changes.singleCourse.currentValue
    // }
  }

  filter(searchText) {
    this.afterFilter = null
    console.log('FILTER CALLED', searchText);
    console.log("value of session=============", this.allSessions);
    this.allSessions = this.allSessionsCopy
    this.filterActive = true;
    if (!searchText) {
      this.units = this.unitsCopy;
      this.allSessions = this.allSessionsCopy
      this.filterActive = false;
      return;
    } else {


      if (this.units && this.units.length) {

        let filteredUnits = this._filter.filter(searchText, this.units, ['title']);
        this.units = filteredUnits
        if (filteredUnits.length <= 0) {
          // this.afterFilter = "No Courses with matched search text found!"
          this.afterFilter = {
            title: "No Units!",
            data: "Sorry, no units matched your search"
          }
        }
      }
      if (this.allSessions && this.allSessions.length) {

        // console.log("this is for portfolio search", searchText);
        // let filterQuiz = this._filter.filter(searchText, this.allSessions, ['title']);
        // console.log("what is the filter array", filterQuiz);

        // this.allSessions = filterQuiz
        // if (filterQuiz.length <= 0) {
        //   // this.afterFilter = "No Courses with matched search text found!"
        //   this.afterFilter = {
        //     title: "No Quiz!",
        //     data: "Sorry, no quiz matched your search"
        //   }
        //   this.filterActive = true
        //   this.loading = false
        // }

        this.afterFilter = null
        this.filterActive = true;
        console.log('FILTER CALLED', searchText);
        if (searchText === '') {
          this.filterActive = false;
          this.allSessions = this.allSessionsCopy
          // this.updateData(this.allSessions);
          return;
        }
        let tempDataSource = this._filter.filter(searchText, this.allSessions, ['title']);
        this.allSessions = tempDataSource
        // this.updateData(tempDataSource)
        if (tempDataSource.length <= 0) {
          this.afterFilter = {
            title: "No Session!",
            data: "Sorry, no sessions matched your search"
          }

        }
      }



    }
  }

  getUserRole() {
    // this.getRole = this._userRoleService.getUserRole(this.job.instructors, 'job');
    // console.log("this.getRole ?? ", this.getRole);
    if (this.userRole == 0) this.isAdmin = true
    // else if (this.userRole == 1) this.isTrainer = true
    // else if (this.userRole == 2) this.isIQA = true
    // else if (this.userRole == 3) this.isLearner = true
    // else if (this.userRole == 4) this.isClient = true
  }

  addUnitModal() {
    let data = {
      isEdit: false,
      courseId: this.courseId
    }
    this.openDialog(AddUnitModalComponent, data).subscribe(res => {
      console.log("add unit response", res)
      if (res == undefined) return
      else {
        this.units.push(res)
        // this.unitsCopy.push(res)
        this.openSnackBar("Unit Added successfully", "OK")
      }
    })
  }

  updateUnit(event) {
    console.log("event while unit is update", event);
    if (event.action == 'edit') {
      let index = this.units.findIndex(x => x._id === event.data._id);
      console.log("value of index", index);
      this.units[index] = event.data
    }
    if (event.action == 'delete') {
      let index = this.units.findIndex(x => x._id === event._id);
      this.units.splice(index, 1)

      this.openSnackBar("Unit Delete successfully", "OK")
      if (this.units && !this.units.length) {
        this.filterActive = true
      }
    }
  }

  // editUnitModal(){
  //   let data = {
  //     title : 'Demo',
  //     unit: 1, 
  //     isEdit: true
  //    }
  //   this.openDialog(AddUnitModalComponent,data).subscribe(res=>{
  //     console.log("add unit response")
  //   })
  // }

  // UTILITY FUNCTIONS

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  // APIs
  // Get material units
  getUnits() {
    this._courseUnitService.getUnits(this.courseId).subscribe(res => {
      this.units = res;
      this.unitsCopy = res;
      console.log("units list by course id", this.units)
      if (this.units && !this.units.length) {
        this.noDataMsg = {
          title: "No Units!",
          data: "Sorry, no units added yet"
        }
        // this.loading
        this.filterActive = false
      }
    })
  }

  // Get course Details
  getCourseById() {
    this.loading = true
    this._courseService.getCourse(this.courseId).subscribe(res => {
      console.log("COURSE IN UNITS", res)
      this.course = res[0]
      this.courseTitle = this.course.title
      this.loading = false
    })
  }

  // get portfolio session
  getSessions(portfolioId) {
    console.log('THIS.COURSE', this.course)

    this._portfolioService.getSessions(portfolioId, undefined, null).subscribe(res => {
      console.log("resss", res[0]);
      this.portfolio = res[0]
      let userRole = JSON.parse(localStorage.getItem('userRoles'))

      this.allSessions = this.portfolio.classRoomSessions.concat(this.portfolio.practicalSessions)
      console.log("all sessoing list with concat", this.allSessions);
      console.log("this user =====++>", userRole);
      // if(this.user.isLearner || this.user.isTrainer){
      this.allSessions = this.allSessions.filter((singleSession) => {
        if (singleSession.quizId && singleSession.quizId.length > 0) {
          return singleSession;
        }
      });
      // }
      this.allSessionsCopy = this.portfolio.classRoomSessions.concat(this.portfolio.practicalSessions)

      const index = this.allSessions.findIndex(x => x.title == 'Tools & Equipment');
      console.log("index of tools and quipment", index);

      let oneQuiz = this.allSessions.filter((o) => {
        return o.title == 'Tools & Equipment'
      })
      console.log("what is single quiz to remove", oneQuiz);
      let quizArray = oneQuiz[0].quizId

      // let id1 = "5f532e54695868276179af47"
      // console.log("index value==========", index);
      quizArray.splice("5f532e54695868276179af47", 1)

      quizArray.splice("5f532629695868276179af37", 1)

      quizArray.splice("5f532abe695868276179af3e", 1)
      console.log("array===========", quizArray);
      // }
      this.loading = false
    })
  }


}
